import Mgr from './SecurityService'
import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './router'
import App from './App.vue'
import axios from 'axios'
import vuetify from './plugins/vuetify';
import store from './store';
import EventHub from './plugins/eventhub';

Vue.use(EventHub);
Vue.use(VueRouter);

let mgr = new Mgr();

function isGranted(userAccess, accessRequired) {
    return userAccess
        .filter((access) => access.isGranted === true)
        .some(item => accessRequired.includes(item.featureId)) || accessRequired.length === 0
  }

axios.interceptors.response.use(response => response, async error => {
    if (error.response.status === 401){
        await mgr.renewToken();
        return axios({
            method: error.response.config.method,
            url: error.response.config.url,
            data: error.response.config.data || ""
        });
    }
    return Promise.reject(error);
});

axios.interceptors.request.use( async config => {
    config.headers = {
        'Authorization': `Bearer ${await mgr.getIdToken()}`
    };
    return config;
});

function isStoreReady() {
    return store.getters.getPermissions.length > 0;
}

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || "VRS - Vessel Requisition System";
    let storeReady = isStoreReady();
    if (to.name !== 'login' && !storeReady) return next({ name: 'login', query: { redirect: to.path } });
    else if (isGranted(store.getters.getPermissions, to.meta.accessRequired || [])) return next();
    else return next("/accessdenied");
});

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app');